import axios from 'axios';
import store from '@/store';

const emailParams = {
  email: '',
  email_title: 'Queen\'s Marque Floorplan',
  sender: 'do_not_reply@adhocstudio.ca',
  sender_name: 'Queen\'s Marque',
  contact: 'Queen\'s Marque',
  pdfPath: [],
  fpNames: []
};

const validEmail = (email) => {
  /* eslint no-useless-escape: 0 */
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};


// const send = async (email, pdfs, names) => {
const send = async (email, floorplans) => {
  if (!validEmail(email)) {
    return {
      status: 'error',
      msg: 'Invalid e-mail, please try again.'
    };
  }

  // emailParams.email = [email];
  // emailParams.pdfPath = pdfs;
  // emailParams.fpNames = names;
  // emailParams.project_id = store.state.project.adhocId;

  emailParams.basic = true;


  emailParams.to = email;
  emailParams.projectName = 'Queen\'s Marque';
  emailParams.projectLogo = 'http://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/images/queens_marque/nav-logo.png';
  emailParams.brandColor = `hsl(204, 25%, 40%)`;
  emailParams.floorplans = floorplans;

  const sales = store.state.project.sales;
  emailParams.salesName = sales.name;
  emailParams.salesEmail = sales.email;
  emailParams.salesNumber = sales.phone;
  emailParams.assetsUrl = store.state.project.assetsUrl;

  // const res = await axios.post('https://adhocstudio.ca/dev/email/EmailMultipleFloorplans.php', emailParams);
  const res = await axios.post('https://adhocstudio.ca/mailer/blackline-email-floorplan.php', emailParams);

  // Logging
  axios.post('https://adhocstudio.ca/feed/recordEmailFloorplanGlobal.php', emailParams);
  if (res.data === 'success') {
    return {
      status: 'success',
      msg: 'Thank you. The floorplan has been sent to your email.'
    };
  }

  console.log(res, emailParams);
  return {
    status: 'error',
    msg: 'There was a problem connecting to the server. Please try again later.'
  };
};

export default {
  send
};



// WEBPACK FOOTER //
// ./src/services/email/index.js